import { UniDealerApiC } from '@unikey/unikey-commons/release/comm'
import { UniIdentityApiID } from '@unikey/unikey-commons/release/identity'

export const partnerKey: string = 'bqt';
export const environment: string = 'staging';
export const isDevelopmentEnv: boolean = environment === 'development';
export const isTesting: boolean = '' as string === 'true'

const commNonceEndpoint = { nonceEndpoint: 'https://bqt-stg-dealer-api.unikey.com/v5/nonces' };
export const api: UniDealerApiC = new UniDealerApiC('https://bqt-stg-dealer-api.unikey.com', 'v5', 'BQT'.toUpperCase(), '8.0.4', { enableLogging: isDevelopmentEnv, isTesting, ...commNonceEndpoint })
export const identityApi: UniIdentityApiID = new UniIdentityApiID('https://identity-stg-bqt.unikey.com', 'api/v1', '71e317be-1dae-4050-9a3b-875ff2b7a2e8', 'AetOU7F3t0WslvOTDUNsdAL3dTh+hk/P00ory3mKY1jbVeyAh/gQxDDGosDtwgtpJ+dk6pm6tmXxmhaQMTgxxw==', '8.0.4', { enableLogging: isDevelopmentEnv && false, isTesting, ...commNonceEndpoint });

export const captchaSiteKey: string = '6Le9gLUjAAAAABDQFbLoMAZo4JT90BmGEAZG6PK5';
export const captchaSecretKey: string = '6Le9gLUjAAAAAKkoVPXAEVS8_NkBzHTSfAUogLRw';

export const termsOfServiceDocument: string = '/legal/termsofuse';
export const privacyPolicyDocument: string = '/legal/privacypolicy';
export const partnerSupportLink: string = 'https://bqtsolutions.com/support/';
export const partnerPortalDomain: string = 'https://bqt-stg-web.unikey.com';
export const deeplinkDomain = 'https://bqt-stg-dealer-web.unikey.com'

export const appleWalletPartnerId: string = 'ORG-739b3368-ab33-42f3-91d8-38af288ce41e';
export const appleWalletSandboxDomain: string = 'https://apple-pay-cert.apple.com';
export const appleWalletDomain: string = 'https://apple-pay.apple.com';

export const appInsightsInstrumentationKey: string = 'cff1c8d2-e97e-44ff-bed5-34d791bb6ac7';
export const mockAuth: string = '';

export const iosAppStoreLink: string = 'true';
export const googlePlayStoreLink: string = 'true';

export const oidcScope: string = 'openid email profile comm.dealer.api identity.api offline_access';
export const oidcClientId: string = '71e317be-1dae-4050-9a3b-875ff2b7a2e8';
export const oidcAuthority: string = 'https://identity-stg-bqt.unikey.com';
export const oidcRedirectUri: string = 'https://bqt-stg-web.unikey.com';
export const oidcRegisterUri: string = '';
export const oidcClientSecret: string = 'AetOU7F3t0WslvOTDUNsdAL3dTh+hk/P00ory3mKY1jbVeyAh/gQxDDGosDtwgtpJ+dk6pm6tmXxmhaQMTgxxw==';
export const oidcPartnerBrandId: string = '36c3290d-07bf-47fc-81e2-0dcf2d685622';
export const oidcPartnerBrandCode: string = 'BQT';
export const oidcSilentRedirectUri: string = 'https://bqt-stg-web.unikey.com';
export const oidcForgotPasswordRedirect: string = '';

export const buildId: string = '50291';
export const releaseId: string = 'Release-340';
export const cdpVersion: string = '8.0.4';
export const commonsVersion: string = '9.17.3-beta-10';
export const desiredLocales: string = 'en,es,ja,fr,pt';

if (isDevelopmentEnv) {
  (window as any).unikey = {
    api, 
    identityApi,
    version: {
      releaseId,
      buildId,
      cdpVersion,
      commonsVersion
    }
  }

  if (!window.isSecureContext) {
    import('./helpers/polyfill.subtle').then(({ setupCryptoPolyfill }) => setupCryptoPolyfill());
  }
}